import React, { useEffect, useState } from 'react';
import { Divider, Header, Icon, Segment, Tab, Table } from 'semantic-ui-react';
import agent from '../../../../app/api/agent';
import { useStore } from '../../../../app/stores/store';

// Use 'any' for the data type
const CircuitHistory: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [postsPerPage] = useState(50);
    let sNo = 1;
    const{activityStore} = useStore()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await agent.HFC.CircuitHistory(activityStore.selectedActivity?.id, 1, postsPerPage);
                setData(response.data);
            } catch (error) {
                console.error('Error fetching circuit history:', error);
                // Handle error appropriately
            }
        };
        fetchData();
            //eslint-disable-next-line
    }, []);

    return (
        <Tab.Pane className="metadata-parent-tab">
          <Segment className="MetaDataUser">
            <Divider horizontal>
              <Header color="teal" as="h4">
                <Icon name="address book outline" />
                Circuit History Location
              </Header>
            </Divider>
            <div style={{ height: '540px', overflowY: 'auto' }}>
            {data.length === 0 ? (
                        <div  style={{
                            margin: '0px',
                            padding: '20px',
                            fontSize:'18px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}>No circuit history to display</div>
                    ) : (
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>S.no</Table.HeaderCell>
                                    <Table.HeaderCell>Theatre</Table.HeaderCell>
                                    <Table.HeaderCell>From Date</Table.HeaderCell>
                                    <Table.HeaderCell>Till Date</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {data.map(item => (
                                    <Table.Row key={item.id}> {/* Add a unique key for each row */}
                                        <Table.Cell>{sNo++}</Table.Cell>
                                        <Table.Cell>{item.theatre}</Table.Cell>
                                        <Table.Cell>{item.from}</Table.Cell>
                                        <Table.Cell>{item.to}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    )}
            </div>
          </Segment>
        </Tab.Pane>
      );
      
};

export default CircuitHistory;
